<input
  [formControl]="formControl"
  [formlyAttributes]="field"
  [attr.placeholder]="props.placeholder || ''"
  [attr.data-id]="field.dataId"
  class="text-input"
  autocomplete="off"
  id="expiration"
  ccExp
/>
